import React from 'react';

const DisabledNotice: React.FC = () => {
  const email = 'crew@heartport.org';
  return (
    <div className="min-h-[40vh] flex items-center justify-center">
      <div className="bg-white/90 text-gray-800 rounded-xl p-6 max-w-lg text-center shadow">
        <h2 className="text-2xl font-bold text-[#49ABDB] mb-2">Account Blocked</h2>
        <p className="mb-4">This account can no longer access the portal. Contact the Heartport team if you believe this was done in error.</p>
        <p>
          Need help? Contact our team at
          {' '}<a href={`mailto:${email}`} className="text-[#47ABDB] underline">{email}</a>.
        </p>
      </div>
    </div>
  );
};

export default DisabledNotice;

